var $14c9042552d7ce08$exports = {};
$14c9042552d7ce08$exports = {
  "Empty": `Bo\u{15F}`
};
export { $14c9042552d7ce08$exports as default };